import { FormNames, IFormDefinition } from '../../models/form/IFormDefinition'
import { extendedInfoFields, extendedInfoFieldValidations } from './ExtendedInfoFields'
import { AppLinks } from '../../environment/app-links'

export const extendedInfoForm: IFormDefinition = {
   name: FormNames.ExtendedInfoForm, 
   fields: extendedInfoFields,
   urlPath: AppLinks.extendedInfoForm,
   nextFormUrlPath: AppLinks.addressInfoForm,
   previousFormUrlPath: AppLinks.basicInfoForm,
   canStepBackInForm: false,
   formValidationFunctions: extendedInfoFieldValidations,
}